"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPEN_ORDERS_COUNTER = exports.REGISTERED_CURRENCY_SEED = exports.ORDER_VAULT_AUTH_SEED = exports.ORDER_VAULT_SEED = exports.MARKET_VARS_SEED = void 0;
exports.MARKET_VARS_SEED = Buffer.from('market-vars');
exports.ORDER_VAULT_SEED = Buffer.from('order-vault-account');
exports.ORDER_VAULT_AUTH_SEED = Buffer.from('order-vault-auth');
exports.REGISTERED_CURRENCY_SEED = Buffer.from('registered-currency');
exports.OPEN_ORDERS_COUNTER = Buffer.from('open-orders-counter');
//# sourceMappingURL=seeds.js.map